export default "__VITE_ASSET__Cbb_brRL__"